

export const SERVICE_PRESCRIPTION_ONLY = "prescription_only";
export const SERVICE_PRESCRIPTION_AND_MEDICATION = "prescription_and_medication";
export const PICKUP = 'pickup';
export const EXPRESS_SHIPPING = 'express_shipping';
export const SHIPPING = 'shipping';
export const SERVICE_FAST_APPROVAL = 'fast_approval';
export const SERVICE_STANDARD_APPROVAL = 'standard_approval';
export const EXPRESS_TIER_KEYS = {
  UBER_2H: `${EXPRESS_SHIPPING}_uber_2h` as const,
  SAME_DAY: `${EXPRESS_SHIPPING}_same_day` as const,
};